const yw = 'xyw.ceramic-copyright.com'
const yt = 'xyt.ceramic-copyright.com'
const protocol_s = true
window.g = {
  // bcn基础服务交易前置地址
  APP_URL_PATH: `${ protocol_s ? 'https' : 'http' }://${ yw }/tradefront`,
  // 新挂牌交易前置front地址（websocket端口）
  APP_URL_PATH2: `${ protocol_s ? 'https' : 'http' }://${ yw }/apigateway`,
  // 配置bcn行情ws服务器地址
  HQ_URL_PATH: `${ protocol_s ? 'wss' : 'ws' }://${ yt }/wsfront_tq`,
  // 配置bcn行情http服务器地址
  TradingView_URL_PATH: `${ protocol_s ? 'https' : 'http' }://${ yt }/qtfront_tq`,
  TOP_REFRESH_TIME: 1000, // top刷新频率
  APP_PROVINCE_CITY: ['贵州省', '贵阳市'],  
  Risk_Right_Time: 1000, // 风险率 当前权益轮询时间
  APP_RUNLOOP_TRADE_ID: 1000, // header 轮循最新成交信息
  APP_RUNLOOP_TIME: 1000, // 轮循查询时间
  TV_REFRESH_TIME: 2000, // k线图标刷新频率
  // 跳转到手机端
  APP_PATH_mobile: `${ protocol_s ? 'https' : 'http' }://${ yw }/mobile/#/?`,
  REGISTER_URLS_CODE:`${ protocol_s ? 'https' : 'http' }://${ yw }/mobile/#/register/0`,
  APP_COMPANY_NAME: '景德镇昌南里陶瓷版权交易中心有限公司', // 公司名
  APP_COMPANYNAME_AB: '景瓷兴', // 公司名简称
  APP_WINNY_NAME: '景瓷兴', // 软件名
  Bank_Id: 40, //连交运
  "Bank_Version": 'V2', // 只有Bank_Id为40可取'V2'; 其他情况取空字符串''
  // 展示头部OTC跳转按钮
  APP_TITLE_CLICK: '景瓷兴',
  APP_TITLE_ALL: '景瓷兴',
  // 控制下单价格变动
  APP_ISAUTOPRICE: true,
  Interface_latency_Time: 1000, // 查询接口 延迟时间
  AXIOS_TIMEOUT: 10000,
  APP_IS_HAIBEI: false,
  // APP_hotline: '客服热线：',
  APP_hotline: '客服电话：400-1726-276',
  APP_TITLELINKS: [
    // 头部跳转链接
    {
      title: '商城',
      url: `${protocol_s ? 'https' : 'http'}://${yw}/pt_client_mall/#/mallIndex/equityMall`
    }
  ],
  APP_market: [
    {
      accountName: '资金系统',
      marketId: 0
    },
    {
      accountName: '订单系统',
      marketId: 28
    },
	{
      accountName: '商城系统',
      marketId: 3
    }
  ],
  FAST_SET: {
    // 挂摘牌时弹出提示确认对话框
    FAST_show_Dialog: true,
    // 挂摘牌成功自动清除挂摘牌信息
    FAST_success_clear: true,
    // 挂摘牌成功使用对话框提示
    FAST_success_Dialog: true,
    // 挂摘牌失败使用对话框提示
    FAST_fail_Dialog: true,
    // 挂摘牌失败自动清除挂摘牌信息
    FAST_fail_clear: true,
    // 撤单时弹出提示确认对话框
    FAST_revoke_Dialog: true,
    // 撤单成功使用对话框提示
    FAST_revoke_success_Dialog: true,
    // 撤单失败使用对话框提示
    FAST_revoke_fail_Dialog: true,
    // 自动填充价格 对手价
    FAST_AutoFill_price: false,
    // 自动填充数量
    FAST_AutoFill_quantity: false
  },
  SETTLEMENT_SYSTEM: true,
}
window.hqc = [
]